import { isNotDefined, isDefined } from "@react-financial-charts/core";

export function saveInteractiveNode(ref) {
	return node => {
		ref.current = node;
	};
}



export function saveInteractiveNodes(ref, type, chartId) {
	return (node) => {
	  if (!ref.current) {
		ref.current = {};
	  }
	  const key = `${type}_${chartId}`;
  
	  if (node) {
		// add or overwrite the entry
		ref.current[key] = { type, chartId, node };
	  } else {
		// cleanup when unmounting
		delete ref.current[key];
	  }
	};
  }

const identity = value => value;
export function getInteractiveNodes(interactiveNodesRef) {
	return interactiveNodesRef.current;
}
export function toObject(array, iteratee = identity) {
	if (!Array.isArray(array)) {
		console.error("Expected an array, but got:", array);
		return {}; // Return an empty object if it's not an array
	}
	return array.reduce((returnObj, a) => {
		const [key, value] = iteratee(a);
		return {
			...returnObj,
			[key]: value
		};
	}, {});
}
